// extracted by mini-css-extract-plugin
module.exports = {"container":"SelectLanguage_container__3xKJO","input":"SelectLanguage_input__2yNuX","flag":"SelectLanguage_flag__2sbjc"};